import { ActionType, NetworkActionPrefix } from '../utils/constants';
import {
    DashboardGroupApi, DashboardPageApi, DashboardPageBlockApi, DashboardPageBlockBubbleSettingsApi, DashboardPageBlockCartesianAxisApi, DashboardPageBlockCartesianSerieApi,
    DashboardPageBlockCartesianSerieGroupingApi, DashboardPageBlockCartesianSerieMilestoneApi, DashboardPageBlockCartesianSerieTypeApi, DashboardPageBlockCommentApi,
    DashboardPageBlockComparisonBarSerieApi, DashboardPageBlockComparisonBarSerieTypeApi, DashboardPageBlockComparisonColumnSerieApi, DashboardPageBlockComparisonColumnSerieTypeApi,
    DashboardPageBlockCustomTableColumnApi, DashboardPageBlockCustomTableQueryApi, DashboardPageBlockExternalSettingsApi, DashboardPageBlockGoogleSheetSettingsApi,
    DashboardPageBlockMilestoneApi, DashboardPageBlockNewsfeedApi, DashboardPageBlockNumberSerieApi, DashboardPageBlockPieSerieApi, DashboardPageBlockPollSettingsApi,
    DashboardPageBlockPowerBIEmbedApi, DashboardPageBlockSerieOrderApi, DashboardPageBlockSolidGaugeSerieApi, DashboardPageBlockStrategicActionApi,
    DashboardPageBlockStrategicActionViewTypeApi, DashboardPageBlockStrategyApi, DashboardPageBlockTableComparisonColumnApi, DashboardPageBlockTableComparisonRowApi,
    DashboardPageBlockTableDataColumnApi, DashboardPageBlockTableEmptyRowApi, DashboardPageBlockTableRollingComparisonApi, DashboardPageBlockTableSerieRowApi,
    DashboardPageBlockTableSerieRowExpandedIndicatorApi, DashboardPageBlockTableSumColumnApi, DashboardPageBlockTypeApi, DashboardPageHomeSettingsApi, DashboardPageUserAccessApi,
    DashboardShareBatchApi, InvoicingDataApi, MapRegionApi, PerformanceIndicatorApi
} from 'for-straction-service-api';
import {
    doubleNestedEntityLifecycleActionSet, entityLifecycleActionSet, nestedEntityLifecycleActionSet, networkAPIAction, tripleNestedEntityLifecycleActionSet
} from '../utils/actionCreatorsFactory';
import { omit } from '../utils';
import { download } from 'typed/utils';


export const loadBlockTypes = () => networkAPIAction(DashboardPageBlockTypeApi, 'dashboardPageBlockTypeLoadAllGet', NetworkActionPrefix.LOAD_BLOCK_TYPES_PREFIX);
export const loadCartesianSerieTypes = () => networkAPIAction(DashboardPageBlockCartesianSerieTypeApi, 'dashboardPageBlockCartesianSerieTypeLoadAllGet', NetworkActionPrefix.LOAD_CARTESIAN_SERIE_TYPES_PREFIX);
export const loadCartesianAxes = () => networkAPIAction(DashboardPageBlockCartesianAxisApi, 'dashboardPageBlockCartesianAxisLoadAllGet', NetworkActionPrefix.LOAD_CARTESIAN_AXES_PREFIX);
export const loadComparisonColumnSerieTypes = () => networkAPIAction(DashboardPageBlockComparisonColumnSerieTypeApi, 'dashboardPageBlockComparisonColumnSerieTypeLoadAllGet', NetworkActionPrefix.LOAD_COMPARISON_COLUMN_SERIE_TYPES_PREFIX);
export const loadComparisonBarSerieTypes = () => networkAPIAction(DashboardPageBlockComparisonBarSerieTypeApi, 'dashboardPageBlockComparisonBarSerieTypeLoadAllGet', NetworkActionPrefix.LOAD_COMPARISON_BAR_SERIE_TYPES_PREFIX);
export const loadSerieOrders = () => networkAPIAction(DashboardPageBlockSerieOrderApi, 'dashboardPageBlockSerieOrderLoadAllGet', NetworkActionPrefix.LOAD_SERIE_ORDERS_PREFIX);

const dashboardGroupActionSet = entityLifecycleActionSet('DashboardGroup', 'DASHBOARD_GROUP', 'dashboardGroup', DashboardGroupApi, {
    loadAll: true,
    load: true,
    add: true,
    edit: true,
    delete: true
}, true);
export const loadAllDashboardGroups = () => dashboardGroupActionSet.loadAllDashboardGroups();
export const loadDashboardGroup = dashboardGroupID => dashboardGroupActionSet.loadDashboardGroup(dashboardGroupID);
export const addDashboardGroup = (dashboardGroup, sync, reloadAfterSync) => dashboardGroupActionSet.addDashboardGroup(dashboardGroup, sync, reloadAfterSync);
export const editDashboardGroup = (dashboardGroup, sync, reloadAfterSync) => dashboardGroupActionSet.editDashboardGroup(dashboardGroup, sync, reloadAfterSync);
export const removeDashboardGroup = dashboardGroupID => dashboardGroupActionSet.removeDashboardGroup(dashboardGroupID);

const dashboardPageActionSet = entityLifecycleActionSet('DashboardPage', 'DASHBOARD_PAGE', 'page', DashboardPageApi, {
    loadAll: 'dashboardPageLoadAllGet',
    load: 'dashboardPageLoadGet',
    add: 'dashboardPageAddPut',
    edit: 'dashboardPageEditPut',
    delete: 'dashboardPageDeleteGet',
    voidAll: true
}, true);
export const loadAllDashboardPages = (maxBlocksCount = 0) => dashboardPageActionSet.loadAllDashboardPages({ maxBlocksCount });
export const loadDashboardPage = (pageID, maxBlocksCount = 0) => dashboardPageActionSet.loadDashboardPage(pageID, { maxBlocksCount });
export const addDashboardPage = (page, sync, reloadAfterSync, maxBlocksCount = 0) => dashboardPageActionSet.addDashboardPage(page, sync, reloadAfterSync, { maxBlocksCount });
export const addDashboardPageFromTemplate = (templateID, groupID, trackingLevelIDs, placeholder) =>
    (dispatch) => {
        dispatch({ type: ActionType.ADD_DASHBOARD_PAGE_FROM_TEMPLATE, templateID, groupID, trackingLevelIDs, placeholder });

        return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageAddFromTemplatePut', NetworkActionPrefix.ADD_DASHBOARD_PAGE_FROM_TEMPLATE_PREFIX, { templateID, groupID, trackingLevelIDs, placeholder }, trackingLevelIDs, templateID, groupID))
            .then(pageID => dispatch(loadDashboardPage(pageID, -1)));
    };
export const editDashboardPage = (page, sync) => dashboardPageActionSet.editDashboardPage(page, sync);
export const cloneDashboardPage = (sourcePageID, changes, targetCompanyID) =>
    (dispatch) => {
        dispatch({ type: ActionType.CLONE_DASHBOARD_PAGE, sourcePageID, changes, targetCompanyID });

        return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageClonePut', NetworkActionPrefix.CLONE_DASHBOARD_PAGE_PREFIX, { sourcePageID, changes, targetCompanyID }, omit(changes, ['ID']), sourcePageID, { targetCompanyID }))
            .then(clonedID => !targetCompanyID ? dispatch(loadDashboardPage(clonedID, -1)) : null);
    };
export const cloneDashboardPageWithFilters = (sourcePageID, copiedPageName, filter) =>
    (dispatch) => {
        dispatch({ type: ActionType.CLONE_DASHBOARD_PAGE_WITH_FILTERS, sourcePageID, copiedPageName, filter });

        return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageCloneWithFiltersPut', NetworkActionPrefix.CLONE_DASHBOARD_PAGE_WITH_FILTERS_PREFIX, { sourcePageID, copiedPageName, filter }, filter, sourcePageID, copiedPageName))
            .then(clonedID => dispatch(loadDashboardPage(clonedID, -1)));
    };

export const deleteAllPageCloneStatuses = sourcePageID => ({ type: ActionType.DELETE_ALL_DASHBOARD_PAGE_CLONE_STATUSES, sourcePageID });

export const removeDashboardPage = pageID => dashboardPageActionSet.removeDashboardPage(pageID);
export const voidAllDashboardPages = () => dashboardPageActionSet.voidAllDashboardPages();

export const moveDashboardBlockToAnotherPage = (pageID, blockID, targetPageID) =>
    (dispatch) => {
        dispatch({ type: ActionType.MOVE_DASHBOARD_BLOCK_TO_ANOTHER_PAGE, pageID, blockID, targetPageID });

        return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageMovePageBlockToAnotherPageGet', NetworkActionPrefix.MOVE_DASHBOARD_BLOCK_TO_ANOTHER_PAGE_PREFIX, { pageID, blockID, targetPageID }, blockID, targetPageID))
            .then(() => dispatch(loadDashboardPage(targetPageID)));
    };

export const storeDashboardPageScreenshot = (pageID, image) => (dispatch) => {
    dispatch({ type: ActionType.STORE_DASHBOARD_PAGE_SCREENSHOT, pageID, image });
    return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageStoreDashboardPageScreenshotPut', NetworkActionPrefix.STORE_DASHBOARD_PAGE_SCREENSHOT_PREFIX, { pageID, image }, image, pageID));
};

export const initDashboardPageBlockImages = (pageID, supportedBlockTypes) =>
    (dispatch) => {
        dispatch({ type: ActionType.INIT_DASHBOARD_PAGE_BLOCK_IMAGES, pageID, supportedBlockTypes });
    };

export const editDashboardBlockImage = (pageID, blockID, blockImage) =>
    (dispatch) => { 
        dispatch({ type: ActionType.EDIT_DASHBOARD_BLOCK_IMAGE, pageID, blockID, blockImage });
    };

export const generateBusinessReviewPdf = (pageID, exportSettings) => (dispatch) => {
    dispatch({ type: ActionType.GENERATE_BUSINESS_REVIEW_PDF, pageID, exportSettings });

    return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageGenerateBusinessReviewPdfPut', NetworkActionPrefix.GENERATE_BUSINESS_REVIEW_PDF_PREFIX, { pageID, exportSettings }, exportSettings))
        .then((response) => {
            if (response) {
                const linkSource = `data:application/pdf;base64,${response}`;
                download(linkSource, exportSettings.FileName);
            }
        });
};

export const addBusinessReview = (pageID, exportSettings) => (dispatch) => {
    dispatch({ type: ActionType.ADD_BUSINESS_REVIEW, pageID, exportSettings });

    return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageAddBusinessReviewPut', NetworkActionPrefix.ADD_BUSINESS_REVIEW_PREFIX, { pageID, exportSettings }, exportSettings));
};

export const addAllDashboardPageUserAccesses = (pageID, userAccesses) =>
    (dispatch) => {
        dispatch({
            type: ActionType.ADD_ALL_DASHBOARD_PAGE_USER_ACCESSES,
            pageID,
            userAccesses
        });

        dispatch(syncNewDashboardPageUserAccesses(pageID, userAccesses));
    };

export const syncNewDashboardPageUserAccesses = (pageID, userAccesses) =>
    networkAPIAction(DashboardPageUserAccessApi, 'dashboardPageUserAccessAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_PAGE_USER_ACCESSES_PREFIX, { pageID, userAccesses }, userAccesses);

export const deleteAllDashboardPageUserAccesses = (pageID, userAccessIDs) =>
    (dispatch) => {
        dispatch({
            type: ActionType.DELETE_ALL_DASHBOARD_PAGE_USER_ACCESSES,
            pageID,
            userAccessIDs
        });

        dispatch(syncDeletedDashboardPageUserAccesses(pageID, userAccessIDs));
    };

export const syncDeletedDashboardPageUserAccesses = (pageID, userAccessIDs) =>
    networkAPIAction(DashboardPageUserAccessApi, 'dashboardPageUserAccessDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_PAGE_USER_ACCESSES_PREFIX, { pageID, userAccessIDs }, userAccessIDs);

const dashboardShareBatchActionSet = entityLifecycleActionSet('DashboardShareBatch', 'DASHBOARD_SHARE_BATCH', 'dashboardShareBatch', DashboardShareBatchApi, { 'add': true });
export const addDashboardShareBatch = (dashboardShareBatch, sync) => dashboardShareBatchActionSet.addDashboardShareBatch(dashboardShareBatch, sync);


const dashboardPageHomeSettingsActionSet = entityLifecycleActionSet('DashboardPageHomeSettings', 'DASHBOARD_PAGE_HOME_SETTINGS', 'dashboardPageHomeSettings', DashboardPageHomeSettingsApi, {
    loadAll: true,
    load: true,
    add: true,
    edit: true,
    delete: true
}, true);
export const loadAllDashboardPageHomeSettings = () => dashboardPageHomeSettingsActionSet.loadAllDashboardPageHomeSettingses();
export const loadDashboardPageHomeSettings = dashboardPageHomeSettingsID => dashboardPageHomeSettingsActionSet.loadDashboardPageHomeSettings(dashboardPageHomeSettingsID);
export const addDashboardPageHomeSettings = (dashboardPageHomeSettings, sync, reloadAfterSync) => dashboardPageHomeSettingsActionSet.addDashboardPageHomeSettings(dashboardPageHomeSettings, sync, reloadAfterSync);
export const editDashboardPageHomeSettings = (dashboardPageHomeSettings, sync, reloadAfterSync) => dashboardPageHomeSettingsActionSet.editDashboardPageHomeSettings(dashboardPageHomeSettings, sync, reloadAfterSync);
export const removeDashboardPageHomeSettings = dashboardPageHomeSettingsID => dashboardPageHomeSettingsActionSet.removeDashboardPageHomeSettings(dashboardPageHomeSettingsID);


const dashboardBlockActionSet = nestedEntityLifecycleActionSet('DashboardBlock', 'DASHBOARD_BLOCK', 'page', 'block', DashboardPageBlockApi, {
    'load': 'dashboardPageBlockLoadGet',
    'add': 'dashboardPageBlockAddPut',
    'edit': 'dashboardPageBlockEditPut',
    'delete': 'dashboardPageBlockDeleteGet'
}, true);
export const loadAllDashboardBlocks = (pageID, { maxCommentsCount } = {}) =>
    networkAPIAction(
        DashboardPageBlockApi,
        'dashboardPageBlockLoadDashboardPageBlockSliceGet',
        NetworkActionPrefix.LOAD_ALL_DASHBOARD_PAGE_BLOCKS_PREFIX,
        { pageID, maxCommentsCount },
        pageID,
        { maxCommentsCount }
    );
export const loadDashboardBlock = (pageID, blockID, { maxCommentsCount } = {}) => dashboardBlockActionSet.loadDashboardBlock(pageID, blockID, { maxCommentsCount });
export const addDashboardBlock = (pageID, block, sync, reloadAfterSync, { maxCommentsCount } = {}) => dashboardBlockActionSet.addDashboardBlock(pageID, block, sync, reloadAfterSync, { maxCommentsCount });
export const addDashboardBlockFromTemplate = (pageID, templateID, x, y, width, heigth, trackingLevelIDs, placeholder) =>
    (dispatch) => {
        dispatch({ type: ActionType.ADD_DASHBOARD_BLOCK_FROM_TEMPLATE, pageID, templateID, x, y, width, heigth, trackingLevelIDs, placeholder });

        return dispatch(networkAPIAction(DashboardPageApi, 'dashboardPageBlockAddFromTemplatePut', NetworkActionPrefix.ADD_DASHBOARD_BLOCK_FROM_TEMPLATE_PREFIX, { pageID, templateID, x, y, width, heigth, trackingLevelIDs, placeholder }, trackingLevelIDs, templateID, pageID, x, y, width, heigth))
            .then(blockID => dispatch(loadDashboardPage(blockID)));
    };
export const editDashboardBlock = (pageID, block, sync, reloadAfterSync, { maxCommentsCount } = {}) => dashboardBlockActionSet.editDashboardBlock(pageID, block, sync, reloadAfterSync, { maxCommentsCount });
export const cloneDashboardBlock = (sourcePageID, sourceBlockID, changes, targetCompanyID) =>
    (dispatch) => {
        dispatch({ type: ActionType.CLONE_DASHBOARD_BLOCK, sourcePageID, sourceBlockID, changes, targetCompanyID });

        return dispatch(networkAPIAction(
            DashboardPageApi,
            'dashboardPageCloneBlockPut',
            NetworkActionPrefix.CLONE_DASHBOARD_BLOCK_PREFIX,
            { sourcePageID, sourceBlockID, changes, targetCompanyID },
            omit(changes, ['ID']),
            sourceBlockID,
            { targetCompanyID }
        ))
            .then(clonedID => !targetCompanyID ?
                changes && changes.PageID !== sourcePageID ?
                    dispatch(loadDashboardPage(changes?.PageID || sourcePageID)) :
                    dispatch(loadDashboardBlock(changes?.PageID || sourcePageID, clonedID)) :
                null
            );
    };
export const deleteAllBlockCloneStatuses = (sourcePageID, sourceBlockID) => ({ type: ActionType.DELETE_ALL_DASHBOARD_BLOCK_CLONE_STATUSES, sourcePageID, sourceBlockID });
export const revertDashboardBlock = (pageID, blockID) => ({ type: ActionType.REVERT_DASHBOARD_BLOCK, pageID, blockID });
export const removeDashboardBlock = (pageID, blockID) => dashboardBlockActionSet.removeDashboardBlock(pageID, blockID);
export const loadAlertBlockSlices = (alertIDs, options = {}) =>
    networkAPIAction(
        DashboardPageBlockApi,
        'dashboardPageBlockLoadAlertBlockSlicesPut',
        NetworkActionPrefix.LOAD_PERFORMANCE_MANAGEMENT_ALERT_BLOCK_SLICES_PREFIX,
        { alertIDs, ...options },
        alertIDs,
        options
    );
export const loadCustomTableBlockData = (pageID, blockID, { startDate, endDate } = {}) =>
    networkAPIAction(
        DashboardPageBlockApi,
        'dashboardPageBlockLoadCustomTableBlockDataGet',
        NetworkActionPrefix.LOAD_CUSTOM_TABLE_BLOCK_DATA_PREFIX,
        { pageID, blockID, startDate, endDate },
        blockID,
        { startDate, endDate }
    );


const dashboardCartesianSerieActionSet = doubleNestedEntityLifecycleActionSet('DashboardCartesianSerie', 'DASHBOARD_CARTESIAN_SERIE', 'page', 'block', 'cartesianSerie', DashboardPageBlockCartesianSerieApi, {
    'add': 'dashboardPageBlockCartesianSerieAddPut',
    'edit': 'dashboardPageBlockCartesianSerieEditPut',
    'delete': 'dashboardPageBlockCartesianSerieDeleteGet'
}, true);
export const addDashboardCartesianSerie = (pageID, blockID, cartesianSerie, sync) => dashboardCartesianSerieActionSet.addDashboardCartesianSerie(pageID, blockID, cartesianSerie, sync);
export const editDashboardCartesianSerie = (pageID, blockID, cartesianSerie, sync) => dashboardCartesianSerieActionSet.editDashboardCartesianSerie(pageID, blockID, cartesianSerie, sync);
export const syncDashboardCartesianSerie = (pageID, blockID, cartesianSerie) => dashboardCartesianSerieActionSet.syncDashboardCartesianSerie(pageID, blockID, cartesianSerie);
export const removeDashboardCartesianSerie = (pageID, blockID, cartesianSerieID) => dashboardCartesianSerieActionSet.removeDashboardCartesianSerie(pageID, blockID, cartesianSerieID);


const dashboardCartesianSerieGroupingActionSet = tripleNestedEntityLifecycleActionSet('DashboardCartesianSerieGrouping', 'DASHBOARD_CARTESIAN_SERIE_GROUPING', 'page', 'block', 'cartesianSerie', 'cartesianSerieGrouping', DashboardPageBlockCartesianSerieGroupingApi, {
    'add': 'dashboardPageBlockCartesianSerieGroupingAddPut',
    'edit': 'dashboardPageBlockCartesianSerieGroupingEditPut',
    'delete': 'dashboardPageBlockCartesianSerieGroupingDeleteGet'
}, true);
export const addDashboardCartesianSerieGrouping = (pageID, blockID, serieID, cartesianSerieGrouping, sync) => dashboardCartesianSerieGroupingActionSet.addDashboardCartesianSerieGrouping(pageID, blockID, serieID, cartesianSerieGrouping, sync);
export const editDashboardCartesianSerieGrouping = (pageID, blockID, serieID, cartesianSerieGrouping, sync) => dashboardCartesianSerieGroupingActionSet.editDashboardCartesianSerieGrouping(pageID, blockID, serieID, cartesianSerieGrouping, sync);
export const syncDashboardCartesianSerieGrouping = (pageID, blockID, serieID, cartesianSerieGrouping) => dashboardCartesianSerieGroupingActionSet.syncDashboardCartesianSerieGrouping(pageID, blockID, serieID, cartesianSerieGrouping);
export const removeDashboardCartesianSerieGrouping = (pageID, blockID, serieID, cartesianSerieGroupingID) => dashboardCartesianSerieGroupingActionSet.removeDashboardCartesianSerieGrouping(pageID, blockID, serieID, cartesianSerieGroupingID);


const dashboardCartesianSerieMilestoneActionSet = entityLifecycleActionSet('DashboardPageBlockCartesianSerieMilestone', 'DASHBOARD_CARTESIAN_SERIE_MILESTONE', 'cartesianSerieMilestone', DashboardPageBlockCartesianSerieMilestoneApi, {
    'loadAll': 'dashboardPageBlockCartesianSerieMilestoneLoadAllGet',
    'add': 'dashboardPageBlockCartesianSerieMilestoneAddPut',
    'edit': 'dashboardPageBlockCartesianSerieMilestoneEditPut',
    'delete': 'dashboardPageBlockCartesianSerieMilestoneDeleteGet'
}, true);
export const loadAllDashboardPageBlockCartesianSerieMilestones = () => dashboardCartesianSerieMilestoneActionSet.loadAllDashboardPageBlockCartesianSerieMilestones();
export const addDashboardPageBlockCartesianSerieMilestone = (cartesianSerieMilestone, sync) => dashboardCartesianSerieMilestoneActionSet.addDashboardPageBlockCartesianSerieMilestone(cartesianSerieMilestone, sync);
export const editDashboardPageBlockCartesianSerieMilestone = (cartesianSerieMilestone, sync) => dashboardCartesianSerieMilestoneActionSet.editDashboardPageBlockCartesianSerieMilestone(cartesianSerieMilestone, sync);
export const syncDashboardPageBlockCartesianSerieMilestone = cartesianSerieMilestone => dashboardCartesianSerieMilestoneActionSet.syncDashboardPageBlockCartesianSerieMilestone(cartesianSerieMilestone);
export const removeDashboardPageBlockCartesianSerieMilestone = cartesianSerieMilestoneID => dashboardCartesianSerieMilestoneActionSet.removeDashboardPageBlockCartesianSerieMilestone(cartesianSerieMilestoneID);


const dashboardComparisonColumnSerieActionSet = doubleNestedEntityLifecycleActionSet('DashboardComparisonColumnSerie', 'DASHBOARD_COMPARISON_COLUMN_SERIE', 'page', 'block', 'comparisonColumnSerie', DashboardPageBlockComparisonColumnSerieApi, {
    'add': 'dashboardPageBlockComparisonColumnSerieAddPut',
    'edit': 'dashboardPageBlockComparisonColumnSerieEditPut',
    'delete': 'dashboardPageBlockComparisonColumnSerieDeleteGet'
}, true);
export const addDashboardComparisonColumnSerie = (pageID, blockID, comparisonColumnSerie, sync) => dashboardComparisonColumnSerieActionSet.addDashboardComparisonColumnSerie(pageID, blockID, comparisonColumnSerie, sync);
export const editDashboardComparisonColumnSerie = (pageID, blockID, comparisonColumnSerie, sync) => dashboardComparisonColumnSerieActionSet.editDashboardComparisonColumnSerie(pageID, blockID, comparisonColumnSerie, sync);
export const syncDashboardComparisonColumnSerie = (pageID, blockID, comparisonColumnSerie) => dashboardComparisonColumnSerieActionSet.syncDashboardComparisonColumnSerie(pageID, blockID, comparisonColumnSerie);
export const removeDashboardComparisonColumnSerie = (pageID, blockID, comparisonColumnSerieID) => dashboardComparisonColumnSerieActionSet.removeDashboardComparisonColumnSerie(pageID, blockID, comparisonColumnSerieID);


const dashboardComparisonBarSerieActionSet = doubleNestedEntityLifecycleActionSet('DashboardComparisonBarSerie', 'DASHBOARD_COMPARISON_BAR_SERIE', 'page', 'block', 'comparisonBarSerie', DashboardPageBlockComparisonBarSerieApi, {
    'add': 'dashboardPageBlockComparisonBarSerieAddPut',
    'edit': 'dashboardPageBlockComparisonBarSerieEditPut',
    'delete': 'dashboardPageBlockComparisonBarSerieDeleteGet'
}, true);
export const addDashboardComparisonBarSerie = (pageID, blockID, comparisonBarSerie, sync) => dashboardComparisonBarSerieActionSet.addDashboardComparisonBarSerie(pageID, blockID, comparisonBarSerie, sync);
export const editDashboardComparisonBarSerie = (pageID, blockID, comparisonBarSerie, sync) => dashboardComparisonBarSerieActionSet.editDashboardComparisonBarSerie(pageID, blockID, comparisonBarSerie, sync);
export const syncDashboardComparisonBarSerie = (pageID, blockID, comparisonBarSerie) => dashboardComparisonBarSerieActionSet.syncDashboardComparisonBarSerie(pageID, blockID, comparisonBarSerie);
export const removeDashboardComparisonBarSerie = (pageID, blockID, comparisonBarSerieID) => dashboardComparisonBarSerieActionSet.removeDashboardComparisonBarSerie(pageID, blockID, comparisonBarSerieID);


const dashboardNewsfeedActionSet = doubleNestedEntityLifecycleActionSet('DashboardNewsfeed', 'DASHBOARD_NEWSFEED', 'page', 'block', 'newsfeed', DashboardPageBlockNewsfeedApi, {
    'edit': 'dashboardPageBlockNewsfeedEditPut'
}, true);
export const editDashboardNewsfeed = (pageID, blockID, newsfeed, sync) => dashboardNewsfeedActionSet.editDashboardNewsfeed(pageID, blockID, newsfeed, sync);
export const syncDashboardNewsfeed = (pageID, blockID, newsfeed) => dashboardNewsfeedActionSet.syncDashboardNewsfeed(pageID, blockID, newsfeed);

const dashboardPieSerieActionSet = doubleNestedEntityLifecycleActionSet('DashboardPieSerie', 'DASHBOARD_PIE_SERIE', 'page', 'block', 'pieSerie', DashboardPageBlockPieSerieApi, {
    'add': 'dashboardPageBlockPieSerieAddPut',
    'edit': 'dashboardPageBlockPieSerieEditPut',
    'delete': 'dashboardPageBlockPieSerieDeleteGet'
}, true);
export const addDashboardPieSerie = (pageID, blockID, pieSerie, sync) => dashboardPieSerieActionSet.addDashboardPieSerie(pageID, blockID, pieSerie, sync);
export const editDashboardPieSerie = (pageID, blockID, pieSerie, sync) => dashboardPieSerieActionSet.editDashboardPieSerie(pageID, blockID, pieSerie, sync);
export const syncDashboardPieSerie = (pageID, blockID, pieSerie) => dashboardPieSerieActionSet.syncDashboardPieSerie(pageID, blockID, pieSerie);
export const removeDashboardPieSerie = (pageID, blockID, pieSerieID) => dashboardPieSerieActionSet.removeDashboardPieSerie(pageID, blockID, pieSerieID);


const dashboardNumberSerieActionSet = doubleNestedEntityLifecycleActionSet('DashboardNumberSerie', 'DASHBOARD_NUMBER_SERIE', 'page', 'block', 'numberSerie', DashboardPageBlockNumberSerieApi, {
    'add': 'dashboardPageBlockNumberSerieAddPut',
    'edit': 'dashboardPageBlockNumberSerieEditPut',
    'delete': 'dashboardPageBlockNumberSerieDeleteGet'
}, true);
export const addDashboardNumberSerie = (pageID, blockID, numberSerie, sync) => dashboardNumberSerieActionSet.addDashboardNumberSerie(pageID, blockID, numberSerie, sync);
export const editDashboardNumberSerie = (pageID, blockID, numberSerie, sync) => dashboardNumberSerieActionSet.editDashboardNumberSerie(pageID, blockID, numberSerie, sync);
export const syncDashboardNumberSerie = (pageID, blockID, numberSerie) => dashboardNumberSerieActionSet.syncDashboardNumberSerie(pageID, blockID, numberSerie);
export const removeDashboardNumberSerie = (pageID, blockID, numberSerieID) => dashboardNumberSerieActionSet.removeDashboardNumberSerie(pageID, blockID, numberSerieID);


const dashboardSolidGaugeSerieActionSet = doubleNestedEntityLifecycleActionSet('DashboardSolidGaugeSerie', 'DASHBOARD_SOLID_GAUGE_SERIE', 'page', 'block', 'solidGaugeSerie', DashboardPageBlockSolidGaugeSerieApi, {
    'add': 'dashboardPageBlockSolidGaugeSerieAddPut',
    'edit': 'dashboardPageBlockSolidGaugeSerieEditPut',
    'delete': 'dashboardPageBlockSolidGaugeSerieDeleteGet'
}, true);
export const addDashboardSolidGaugeSerie = (pageID, blockID, solidGaugeSerie, sync) => dashboardSolidGaugeSerieActionSet.addDashboardSolidGaugeSerie(pageID, blockID, solidGaugeSerie, sync);
export const editDashboardSolidGaugeSerie = (pageID, blockID, solidGaugeSerie, sync) => dashboardSolidGaugeSerieActionSet.editDashboardSolidGaugeSerie(pageID, blockID, solidGaugeSerie, sync);
export const syncDashboardSolidGaugeSerie = (pageID, blockID, solidGaugeSerie) => dashboardSolidGaugeSerieActionSet.syncDashboardSolidGaugeSerie(pageID, blockID, solidGaugeSerie);
export const removeDashboardSolidGaugeSerie = (pageID, blockID, solidGaugeSerieID) => dashboardSolidGaugeSerieActionSet.removeDashboardSolidGaugeSerie(pageID, blockID, solidGaugeSerieID);


const dashboardExternalSettingsActionSet = doubleNestedEntityLifecycleActionSet('DashboardExternalSettings', 'DASHBOARD_EXTERNAL_SETTINGS', 'page', 'block', 'externalSettings', DashboardPageBlockExternalSettingsApi, {
    'edit': 'dashboardPageBlockExternalSettingsEditPut'
}, true);
export const editDashboardExternalSettings = (pageID, blockID, externalSettings, sync) => dashboardExternalSettingsActionSet.editDashboardExternalSettings(pageID, blockID, externalSettings, sync);


const dashboardPageBlockPollSettingsActionSet = doubleNestedEntityLifecycleActionSet('DashboardPageBlockPollSettings', 'DASHBOARD_BLOCK_POLL_SETTINGS', 'page', 'block', 'indicatorPollSettings', DashboardPageBlockPollSettingsApi, {
    'add': 'dashboardPageBlockPollSettingsAddPut',
    'edit': 'dashboardPageBlockPollSettingsEditPut',
    'delete': 'dashboardPageBlockPollSettingsDeleteGet'
}, true);

export const addDashboardPageBlockPollSettings = (pageID, blockID, indicatorPollSettings, sync) => dashboardPageBlockPollSettingsActionSet.addDashboardPageBlockPollSettings(pageID, blockID, indicatorPollSettings, sync);
export const editDashboardPageBlockPollSettings = (pageID, blockID, indicatorPollSettings, sync) => dashboardPageBlockPollSettingsActionSet.editDashboardPageBlockPollSettings(pageID, blockID, indicatorPollSettings, sync);
export const removeDashboardPageBlockPollSettings = (pageID, blockID, indicatorPollSettings) => dashboardPageBlockPollSettingsActionSet.removeDashboardPageBlockPollSettings(pageID, blockID, indicatorPollSettings);


export const addAllDashboardTableRollingComparisons = (pageID, blockID, tableRollingComparisons, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_TABLE_ROLLING_COMPARISONS, pageID, blockID, tableRollingComparisons });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableRollingComparisonApi, 'dashboardPageBlockTableRollingComparisonAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_TABLE_ROLLING_COMPARISONS_PREFIX, { pageID, blockID, tableRollingComparisons }, tableRollingComparisons
            ))
                .then(resolve, reject);
        }
    });
export const editAllDashboardTableRollingComparisons = (pageID, blockID, tableRollingComparisons, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_TABLE_ROLLING_COMPARISONS, pageID, blockID, tableRollingComparisons });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableRollingComparisonApi, 'dashboardPageBlockTableRollingComparisonEditAllPut', NetworkActionPrefix.EDIT_ALL_DASHBOARD_TABLE_ROLLING_COMPARISONS_PREFIX, { pageID, blockID, tableRollingComparisons }, tableRollingComparisons
            ))
                .then(resolve, reject);
        }
    });
export const removeAllDashboardTableRollingComparisons = (pageID, blockID, tableRollingComparisonIDs) => networkAPIAction(
    DashboardPageBlockTableRollingComparisonApi, 'dashboardPageBlockTableRollingComparisonDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_TABLE_ROLLING_COMPARISONS_PREFIX, { pageID, blockID, tableRollingComparisonIDs }, tableRollingComparisonIDs
);


export const addAllDashboardTableDataColumns = (pageID, blockID, tableDataColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_TABLE_DATA_COLUMNS, pageID, blockID, tableDataColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableDataColumnApi, 'dashboardPageBlockTableDataColumnAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_TABLE_DATA_COLUMNS_PREFIX, { pageID, blockID, tableDataColumns }, tableDataColumns
            ))
                .then(resolve, reject);
        }
    });
export const editAllDashboardTableDataColumns = (pageID, blockID, tableDataColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_TABLE_DATA_COLUMNS, pageID, blockID, tableDataColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableDataColumnApi, 'dashboardPageBlockTableDataColumnEditAllPut', NetworkActionPrefix.EDIT_ALL_DASHBOARD_TABLE_DATA_COLUMNS_PREFIX, { pageID, blockID, tableDataColumns }, tableDataColumns
            ))
                .then(resolve, reject);
        }
    });
export const removeAllDashboardTableDataColumns = (pageID, blockID, tableDataColumnIDs) => networkAPIAction(
    DashboardPageBlockTableDataColumnApi, 'dashboardPageBlockTableDataColumnDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_TABLE_DATA_COLUMNS_PREFIX, { pageID, blockID, tableDataColumnIDs }, tableDataColumnIDs
);


export const addAllDashboardTableComparisonColumns = (pageID, blockID, tableComparisonColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_TABLE_COMPARISON_COLUMNS, pageID, blockID, tableComparisonColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableComparisonColumnApi, 'dashboardPageBlockTableComparisonColumnAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_TABLE_COMPARISON_COLUMNS_PREFIX, { pageID, blockID, tableComparisonColumns }, tableComparisonColumns
            ))
                .then(resolve, reject);
        }
    });
export const editAllDashboardTableComparisonColumns = (pageID, blockID, tableComparisonColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_TABLE_COMPARISON_COLUMNS, pageID, blockID, tableComparisonColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableComparisonColumnApi, 'dashboardPageBlockTableComparisonColumnEditAllPut', NetworkActionPrefix.EDIT_ALL_DASHBOARD_TABLE_COMPARISON_COLUMNS_PREFIX, { pageID, blockID, tableComparisonColumns }, tableComparisonColumns
            ))
                .then(resolve, reject);
        }
    });
export const removeAllDashboardTableComparisonColumns = (pageID, blockID, tableComparisonColumnIDs) => networkAPIAction(
    DashboardPageBlockTableComparisonColumnApi, 'dashboardPageBlockTableComparisonColumnDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_TABLE_COMPARISON_COLUMNS_PREFIX, { pageID, blockID, tableComparisonColumnIDs }, tableComparisonColumnIDs
);


export const addAllDashboardTableSumColumns = (pageID, blockID, tableSumColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_TABLE_SUM_COLUMNS, pageID, blockID, tableSumColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableSumColumnApi, 'dashboardPageBlockTableSumColumnAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_TABLE_SUM_COLUMNS_PREFIX, { pageID, blockID, tableSumColumns }, tableSumColumns
            ))
                .then(resolve, reject);
        }
    });
export const editAllDashboardTableSumColumns = (pageID, blockID, tableSumColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_TABLE_SUM_COLUMNS, pageID, blockID, tableSumColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableSumColumnApi, 'dashboardPageBlockTableSumColumnEditAllPut', NetworkActionPrefix.EDIT_ALL_DASHBOARD_TABLE_SUM_COLUMNS_PREFIX, { pageID, blockID, tableSumColumns }, tableSumColumns
            ))
                .then(resolve, reject);
        }
    });
export const removeAllDashboardTableSumColumns = (pageID, blockID, tableSumColumnIDs) => networkAPIAction(
    DashboardPageBlockTableSumColumnApi, 'dashboardPageBlockTableSumColumnDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_TABLE_SUM_COLUMNS_PREFIX, { pageID, blockID, tableSumColumnIDs }, tableSumColumnIDs
);


export const addAllDashboardTableSerieRows = (pageID, blockID, tableSerieRows, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_TABLE_SERIE_ROWS, pageID, blockID, tableSerieRows });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableSerieRowApi, 'dashboardPageBlockTableSerieRowAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_TABLE_SERIE_ROWS_PREFIX, { pageID, blockID, tableSerieRows }, tableSerieRows
            ))
                .then(resolve, reject);
        }
    });
export const editAllDashboardTableSerieRows = (pageID, blockID, tableSerieRows, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_TABLE_SERIE_ROWS, pageID, blockID, tableSerieRows });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableSerieRowApi, 'dashboardPageBlockTableSerieRowEditAllPut', NetworkActionPrefix.EDIT_ALL_DASHBOARD_TABLE_SERIE_ROWS_PREFIX, { pageID, blockID, tableSerieRows }, tableSerieRows
            ))
                .then(resolve, reject);
        }
    });
export const removeAllDashboardTableSerieRows = (pageID, blockID, tableSerieRowIDs) => networkAPIAction(
    DashboardPageBlockTableSerieRowApi, 'dashboardPageBlockTableSerieRowDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_TABLE_SERIE_ROWS_PREFIX, { pageID, blockID, tableSerieRowIDs }, tableSerieRowIDs
);


const tableSerieRowExpandedIndicatorActionSet = tripleNestedEntityLifecycleActionSet('DashboardSerieRowExpandedIndicator', 'DASHBOARD_TABLE_SERIE_ROW_EXPANDED_INDICATOR', 'page', 'block', 'tableSerieRow', 'serieRowExpandedIndicator', DashboardPageBlockTableSerieRowExpandedIndicatorApi, {
    'add': 'dashboardPageBlockTableSerieRowExpandedIndicatorAddPut',
    'delete': 'dashboardPageBlockTableSerieRowExpandedIndicatorDeleteGet'
}, true);

export const addDashboardSerieRowExpandedIndicator = (pageID, blockID, tableSerieRowID, serieRowExpandedIndicator, sync) => tableSerieRowExpandedIndicatorActionSet.addDashboardSerieRowExpandedIndicator(pageID, blockID, tableSerieRowID, serieRowExpandedIndicator, sync);
export const removeDashboardSerieRowExpandedIndicator = (pageID, blockID, tableSerieRowID, serieRowExpandedIndicatorID) => tableSerieRowExpandedIndicatorActionSet.removeDashboardSerieRowExpandedIndicator(pageID, blockID, tableSerieRowID, serieRowExpandedIndicatorID);


export const addAllDashboardTableComparisonRows = (pageID, blockID, tableComparisonRows, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_TABLE_COMPARISON_ROWS, pageID, blockID, tableComparisonRows });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableComparisonRowApi, 'dashboardPageBlockTableComparisonRowAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_TABLE_COMPARISON_ROWS_PREFIX, { pageID, blockID, tableComparisonRows }, tableComparisonRows
            ))
                .then(resolve, reject);
        }
    });
export const editAllDashboardTableComparisonRows = (pageID, blockID, tableComparisonRows, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_TABLE_COMPARISON_ROWS, pageID, blockID, tableComparisonRows });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableComparisonRowApi, 'dashboardPageBlockTableComparisonRowEditAllPut', NetworkActionPrefix.EDIT_ALL_DASHBOARD_TABLE_COMPARISON_ROWS_PREFIX, { pageID, blockID, tableComparisonRows }, tableComparisonRows
            ))
                .then(resolve, reject);
        }
    });
export const removeAllDashboardTableComparisonRows = (pageID, blockID, tableComparisonRowIDs) => networkAPIAction(
    DashboardPageBlockTableComparisonRowApi, 'dashboardPageBlockTableComparisonRowDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_TABLE_COMPARISON_ROWS_PREFIX, { pageID, blockID, tableComparisonRowIDs }, tableComparisonRowIDs
);


export const addAllDashboardTableEmptyRows = (pageID, blockID, tableEmptyRows, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_TABLE_EMPTY_ROWS, pageID, blockID, tableEmptyRows });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableEmptyRowApi, 'dashboardPageBlockTableEmptyRowAddAllPut', NetworkActionPrefix.ADD_ALL_DASHBOARD_TABLE_EMPTY_ROWS_PREFIX, { pageID, blockID, tableEmptyRows }, tableEmptyRows
            ))
                .then(resolve, reject);
        }
    });
export const editAllDashboardTableEmptyRows = (pageID, blockID, tableEmptyRows, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_TABLE_EMPTY_ROWS, pageID, blockID, tableEmptyRows });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockTableEmptyRowApi, 'dashboardPageBlockTableEmptyRowEditAllPut', NetworkActionPrefix.EDIT_ALL_DASHBOARD_TABLE_EMPTY_ROWS_PREFIX, { pageID, blockID, tableEmptyRows }, tableEmptyRows
            ))
                .then(resolve, reject);
        }
    });
export const removeAllDashboardTableEmptyRows = (pageID, blockID, tableEmptyRowIDs) => networkAPIAction(
    DashboardPageBlockTableEmptyRowApi, 'dashboardPageBlockTableEmptyRowDeleteAllPut', NetworkActionPrefix.DELETE_ALL_DASHBOARD_TABLE_EMPTY_ROWS_PREFIX, { pageID, blockID, tableEmptyRowIDs }, tableEmptyRowIDs
);


const dashboardBlockPowerBIEmbedActionSet = doubleNestedEntityLifecycleActionSet('DashboardPageBlockPowerBIEmbed', 'DASHBOARD_BLOCK_POWER_BI_EMBED', 'page', 'block', 'powerBIEmbed', DashboardPageBlockPowerBIEmbedApi, {
    'edit': 'dashboardPageBlockPowerBIEmbedEditPut'
}, true);
export const editDashboardBlockPowerBIEmbed = (pageID, blockID, powerBIEmbed, sync) => dashboardBlockPowerBIEmbedActionSet.editDashboardPageBlockPowerBIEmbed(pageID, blockID, powerBIEmbed, sync);

export const generatePowerBIEmbedToken = (pageID, blockID) =>
    networkAPIAction(
        DashboardPageBlockPowerBIEmbedApi,
        'dashboardPageBlockPowerBIEmbedGenerateEmbedTokenGet',
        NetworkActionPrefix.GENERATE_POWER_BI_EMBED_TOKEN_PREFIX,
        { pageID, blockID },
        blockID
    );


export const loadDashboardComments = (pageID, blockID, { startID, maxCount } = {}) =>
    networkAPIAction(DashboardPageBlockCommentApi, 'dashboardPageBlockCommentSearchSlicePut', NetworkActionPrefix.LOAD_DASHBOARD_COMMENTS_PREFIX, { pageID, blockID }, { BlockID: blockID }, { startID, maxCount });

export const addDashboardComment = (pageID, blockID, comment) =>
    (dispatch) => {
        dispatch({
            type: ActionType.ADD_DASHBOARD_COMMENT,
            pageID,
            blockID,
            commentID: comment.ID,
            comment
        });

        dispatch(syncDashboardComment(pageID, blockID, comment));
    };

export const syncDashboardComment = (pageID, blockID, comment) =>
    networkAPIAction(DashboardPageBlockCommentApi, 'dashboardPageBlockCommentAddPut', NetworkActionPrefix.ADD_DASHBOARD_COMMENT_PREFIX, { pageID, blockID, commentID: comment.ID }, comment);

const dashboardStrategicActionActionSet = doubleNestedEntityLifecycleActionSet('DashboardStrategicAction', 'DASHBOARD_STRATEGIC_ACTION', 'page', 'block', 'strategicAction', DashboardPageBlockStrategicActionApi, {
    'add': 'dashboardPageBlockStrategicActionAddPut',
    'edit': 'dashboardPageBlockStrategicActionEditPut',
    'delete': 'dashboardPageBlockStrategicActionDeleteGet'
}, true);

export const addDashboardStrategicAction = (pageID, blockID, strategicAction, sync) => dashboardStrategicActionActionSet.addDashboardStrategicAction(pageID, blockID, strategicAction, sync);
export const editDashboardStrategicAction = (pageID, blockID, strategicAction, sync) => dashboardStrategicActionActionSet.editDashboardStrategicAction(pageID, blockID, strategicAction, sync);
export const syncDashboardStrategicAction = (pageID, blockID, strategicAction) => dashboardStrategicActionActionSet.syncDashboardStrategicAction(pageID, blockID, strategicAction);
export const removeDashboardStrategicAction = (pageID, blockID, strategicActionID) => dashboardStrategicActionActionSet.removeDashboardStrategicAction(pageID, blockID, strategicActionID);

export const loadAllDashboardStrategicActionViewTypes = () =>
    networkAPIAction(DashboardPageBlockStrategicActionViewTypeApi, 'dashboardPageBlockStrategicActionViewTypeLoadAllGet', NetworkActionPrefix.LOAD_ALL_DASHBOARD_STRATEGIC_ACTION_VIEW_TYPES_PREFIX, {});


export const searchDashboardIndicatorAvailability = templates =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorSearchAvailabilityReportPut', NetworkActionPrefix.SEARCH_DASHBOARD_INDICATOR_AVAILABILITY_PREFIX, { templates }, templates);

export const searchDashboardIndicatorData = templates =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorSearchDataReportPut', NetworkActionPrefix.SEARCH_DASHBOARD_INDICATOR_DATA_PREFIX, { templates }, templates);

export const searchDashboardIndicatorDrillData = filters =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorSearchDrillDataPut', NetworkActionPrefix.SEARCH_DASHBOARD_INDICATOR_DRILL_DATA_PREFIX, { filters }, filters.CorporateStructureLink, filters.IndicatorID, filters.PeriodTypeID, filters.PeriodStart, filters.PeriodEnd, filters.PointCalculationID, filters.DimensionID);

export const voidDashboardIndicatorData = (indicatorIDs = null, immediately = true, soft = false) => ({ type: ActionType.VOID_DASHBOARD_INDICATOR_DATA, indicatorIDs, immediately, soft });

export const loadMapDataReport = (corporateStructureFilter, startDate, endDate, { maxInvoicesCount } = {}) =>
    networkAPIAction(MapRegionApi, 'mapRegionLoadDataReportPut', NetworkActionPrefix.LOAD_MAP_DATA_REPORT_PREFIX, { corporateStructureFilter, startDate, endDate, maxInvoicesCount }, corporateStructureFilter, startDate, endDate, { maxInvoicesCount });

export const searchMapDataReportInvoicesSlice = (regionID, corporateStructureFilter, startDate, endDate, { startID, maxCount } = {}) =>
    networkAPIAction(InvoicingDataApi, 'invoicingDataSearchLightReportSlicePut', NetworkActionPrefix.SEARCH_MAP_DATA_REPORT_INVOICES_SLICE_PREFIX, { regionID, corporateStructureFilter, startDate, endDate, startID, maxCount }, corporateStructureFilter, regionID, { startDate, endDate, startID, maxCount });

export const voidMapDataReport = () => ({ type: ActionType.VOID_MAP_DATA_REPORT });

const dashboardPageBlockBubbleSettingsActionSet = doubleNestedEntityLifecycleActionSet('DashboardPageBlockBubbleSettings', 'DASHBOARD_BLOCK_BUBBLE_SETTINGS', 'page', 'block', 'bubbleSettings', DashboardPageBlockBubbleSettingsApi, {
    'add': 'dashboardPageBlockBubbleSettingsAddPut',
    'edit': 'dashboardPageBlockBubbleSettingsEditPut'
}, true);

export const addDashboardPageBlockBubbleSettings = (pageID, blockID, bubbleSettings, sync) => dashboardPageBlockBubbleSettingsActionSet.addDashboardPageBlockBubbleSettings(pageID, blockID, bubbleSettings, sync);
export const editDashboardPageBlockBubbleSettings = (pageID, blockID, bubbleSettings, sync) => dashboardPageBlockBubbleSettingsActionSet.editDashboardPageBlockBubbleSettings(pageID, blockID, bubbleSettings, sync);

const dashboardGoogleSheetSettingsActionSet = doubleNestedEntityLifecycleActionSet('DashboardGoogleSheetSettings', 'DASHBOARD_GOOGLE_SHEET_SETTINGS', 'page', 'block', 'googleSheetSettings', DashboardPageBlockGoogleSheetSettingsApi, {
    'edit': 'dashboardPageBlockGoogleSheetSettingsEditPut'
}, true);
export const editDashboardGoogleSheetSettings = (pageID, blockID, googleSheetSettings, sync) => dashboardGoogleSheetSettingsActionSet.editDashboardGoogleSheetSettings(pageID, blockID, googleSheetSettings, sync);


const dashboardPageBlockCustomTableQueryActionSet = doubleNestedEntityLifecycleActionSet('DashboardPageBlockCustomTableQuery', 'DASHBOARD_BLOCK_CUSTOM_TABLE_QUERY', 'page', 'block', 'customTableQuery', DashboardPageBlockCustomTableQueryApi, {
    'edit': 'dashboardPageBlockCustomTableQueryRestrictedEditPut'
}, true);
export const editDashboardPageBlockCustomTableQuery = (pageID, blockID, customTableQuery, sync) => dashboardPageBlockCustomTableQueryActionSet.editDashboardPageBlockCustomTableQuery(pageID, blockID, customTableQuery, sync);


export const addAllDashboardCustomTableColumns = (pageID, blockID, customTableColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_DASHBOARD_CUSTOM_TABLE_COLUMNS, pageID, blockID, customTableColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockCustomTableColumnApi,
                'dashboardPageBlockCustomTableColumnRestrictedAddAllPut',
                NetworkActionPrefix.ADD_ALL_DASHBOARD_CUSTOM_TABLE_COLUMNS_PREFIX,
                { pageID, blockID, customTableColumns },
                customTableColumns
            )).then(resolve, reject);
        }
    });
export const editAllDashboardCustomTableColumns = (pageID, blockID, customTableColumns, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_DASHBOARD_CUSTOM_TABLE_COLUMNS, pageID, blockID, customTableColumns });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(
                DashboardPageBlockCustomTableColumnApi,
                'dashboardPageBlockCustomTableColumnRestrictedEditAllPut',
                NetworkActionPrefix.EDIT_ALL_DASHBOARD_CUSTOM_TABLE_COLUMNS_PREFIX,
                { pageID, blockID, customTableColumns },
                customTableColumns
            )).then(resolve, reject);
        }
    });
export const deleteAllDashboardCustomTableColumns = (pageID, blockID, customTableColumnIDs) =>
    networkAPIAction(
        DashboardPageBlockCustomTableColumnApi,
        'dashboardPageBlockCustomTableColumnDeleteAllPut',
        NetworkActionPrefix.DELETE_ALL_DASHBOARD_CUSTOM_TABLE_COLUMNS_PREFIX,
        { pageID, blockID, customTableColumnIDs },
        customTableColumnIDs
    );

const dashboardStrategyActionSet = doubleNestedEntityLifecycleActionSet('DashboardPageBlockStrategy', 'DASHBOARD_BLOCK_STRATEGY', 'page', 'block', 'strategySettings', DashboardPageBlockStrategyApi, {
    'edit': 'dashboardPageBlockStrategyEditPut'
}, true);
export const editDashboardPageBlockStrategy = (pageID, blockID, strategySettings, sync) => dashboardStrategyActionSet.editDashboardPageBlockStrategy(pageID, blockID, strategySettings, sync);

const dashboardMilestoneActionSet =
    doubleNestedEntityLifecycleActionSet('DashboardPageBlockMilestone', 'DASHBOARD_BLOCK_MILESTONE', 'page', 'block', 'milestoneSettings', DashboardPageBlockMilestoneApi, {
        'edit': 'dashboardPageBlockMilestoneEditPut'
    }, true);
export const editDashboardPageBlockMilestone = (pageID, blockID, milestoneSettings, sync) =>
    dashboardMilestoneActionSet.editDashboardPageBlockMilestone(pageID, blockID, milestoneSettings, sync);
